const NO_CONTENT = 204;

export default { NO_CONTENT, };